import { FormControlLabel, FormHelperText, Switch } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface SegmentationToggleRowProps {
  enabled: boolean;
  onToggle: (checked: boolean) => void;
  hasColumns: boolean;
}

/**
 * Toggle row to enable/disable segmentation, with optional message when no columns are selected.
 */
export function SegmentationToggleRow({
  enabled,
  onToggle,
  hasColumns,
}: SegmentationToggleRowProps) {
  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={enabled}
            onChange={(e) => onToggle(e.target.checked)}
            disabled={!hasColumns}
          />
        }
        label={
          <FormattedMessage
            id="audit.reportDefinitions.segmentation.splitReport"
            defaultMessage="Dividir en secciones para una de las columnas"
          />
        }
      />
      {!hasColumns && (
        <FormHelperText>
          <FormattedMessage
            id="audit.reportDefinitions.segmentation.noColumns"
            defaultMessage="Debes seleccionar al menos una columna para poder agrupar."
          />
        </FormHelperText>
      )}
    </>
  );
}
